import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Colecao } from 'src/app/models/api/comercial/colecao';

@Injectable({
  providedIn: 'root'
})
export class ApiColecaoService {
  private baseUrl = 'Colecao';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Colecao[]>('');
  }
}
